import { createAsyncThunk } from '@reduxjs/toolkit';
import { ToppingsCategory } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchToppingsCategory, FindToppingsCategory, GetToppingsCategory } from './interface';

export const createToppingsCategory = createAsyncThunk(
  'toppingsCategory/createToppingsCategory',
  async (values: CreatePatchToppingsCategory, { rejectWithValue }) => {
    try {
      const response = await ToppingsCategory.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const findToppingsCategory = createAsyncThunk('toppingsCategory/findToppingsCategory', async (values: FindToppingsCategory, { rejectWithValue }) => {
  try {
    const response = await ToppingsCategory.find({
      query: values,
    });

    return response;
  } catch (error: any) {
    toastHandler(error);
    return rejectWithValue(error.message);
  }
});

export const getToppingsCategory = createAsyncThunk(
  'toppingsCategory/getToppingsCategory',
  async ({ id }: GetToppingsCategory, { rejectWithValue }) => {
    try {
      const response = await ToppingsCategory.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchToppingsCategory = createAsyncThunk(
  'toppingsCategory/patchToppingsCategory',
  async ({ id, ...values }: CreatePatchToppingsCategory, { rejectWithValue }) => {
    try {
      const response = await ToppingsCategory.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
